<template lang="pug">
  #app.page
    Header

    router-view

    PopupBooking
    PopupEvent
    PopupMessage
    Preloader
</template>

<script>
  import Header from '@/components/common/header/Header';
  import Preloader from '@/components/common/preloader/Preloader.vue';

  import PopupBooking from '@/components/common/popups/popupBooking/PopupBooking.vue';
  import PopupEvent from '@/components/common/popups/popupEvent/PopupEvent.vue';
  import PopupMessage from '@/components/common/popups/popupMessage/popupMessage.vue';

  export default {
    components: {
      Header,
      PopupBooking,
      PopupEvent,
      Preloader,
      PopupMessage
    }
  }
</script>
